import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  adminUsersPage: {
    backgroundColor: 'var(--background-default)',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',

    '& .header': {
      height: '100%',
      maxHeight: '48px',
    },

    '& strong': {
      color: 'var(--text-primary)',
    },

    '& > .container': {
      height: 'calc(100% - 40px)',

      '& .containerContent': {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      },

      '@media screen and (min-width: 1441px)': {
        height: 'calc(100% - 48px)',
      },
    },

    '& .cellName': {
      width: '100%',

      '&:not(:last-child)': {
        margin: '0 8px 0 0',
      },

      '&.role, &.tier, &.finance-status': {
        fontWeight: 500,
        textTransform: 'capitalize',
      },

      '&.tools': {
        maxWidth: '30px',

        '@media screen and (min-width: 1441px)': {
          maxWidth: '36px',
        },
      },

      '&.photo': {
        maxWidth: '72px',

        '& .viboImage': {
          width: '72px',
          height: '72px',

          '@media screen and (min-width: 1441px)': {
            width: '92px',
            height: '92px',
          },
        },

        '@media screen and (min-width: 1441px)': {
          maxWidth: '92px',
        },
      },

      '&.name': {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        maxWidth: '260px',

        '& .fullName, & .email': {
          ...mixins.longText,
        },

        '& .fullName': {
          fontWeight: 500,
          fontSize: '15px',

          '@media screen and (min-width: 1441px)': {
            fontSize: '18px',
          },
        },

        '& .email': {
          fontSize: '13px',

          '@media screen and (min-width: 1441px)': {
            fontSize: '16px',
          },
        },

        '@media screen and (min-width: 1441px)': {
          gap: '11px',
          maxWidth: '340px',
        },
      },

      '&.role': {
        maxWidth: '220px',

        '@media screen and (min-width: 1441px)': {
          maxWidth: '320px',
        },
      },

      '&.tier': {
        maxWidth: '160px',

        '@media screen and (min-width: 1441px)': {
          maxWidth: '240px',
        },
      },

      '&.finance-status': {
        maxWidth: '140px',

        '& .viboSelect__control': {
          whiteSpace: 'nowrap',
          flexWrap: 'nowrap',
        },

        '@media screen and (min-width: 1441px)': {
          maxWidth: '200px',
        },
      },
    },
  },

  usersHeader: {
    width: '100%',
    display: 'flex',
    padding: '0 6px 6px 6px',

    '& .cellName': {
      '& .viboSelect .highlighted': {
        ...mixins.longText,
        maxWidth: '100px',
      },
    },
  },

  userRow: {
    cursor: 'pointer',
    padding: '6px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '88px',

    '@media screen and (min-width: 1441px)': {
      height: '108px',
    },
  },

  roleInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',

    '& .label': {
      ...mixins.longText,
      width: '90%',
      color: 'var(--text-secondary)',
      fontWeight: 400,
      fontSize: '13px',

      '@media screen and (min-width: 1441px)': {
        fontSize: '16px',
      },
    },

    '& > .viboButton': {
      color: 'var(--primary-main)',
    },

    '@media screen and (min-width: 1441px)': {
      gap: '8px',
    },
  },

  eventsWrap: {
    width: '100%',
    maxWidth: '1155px',
    display: 'flex',
    alignSelf: 'center',
  },

  events: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gridColumnStart: 2,
    gridColumnEnd: 3,
  },

  eventsTable: {
    borderCollapse: 'separate',
    borderSpacing: '0 4px',
    width: '100%',
    paddingTop: '11px',
  },

  eventItem: {
    height: '80px',
    padding: '15px',
    transition: '0.2s',
    borderRadius: '4px',
    boxShadow: 'var(--shadows-4)',

    '&:hover': {
      boxShadow: 'var(--shadows-8)',
      cursor: 'pointer',
    },
  },

  eventHeader: {
    boxShadow: 'var(--shadows-4)',
    borderRadius: '4px',

    '& svg': {
      marginLeft: '5px',
    },
  },

  proTierLabel: {
    position: 'absolute',
    right: '4px',
    top: '4px',
    lineHeight: 'inherit',
  },

  usersCounter: {
    display: 'flex',
    flexDirection: 'row',
    fontWeight: 500,
    fontSize: '20px',
    gap: '8px',

    '& span': {
      fontWeight: 400,
    },

    '@media screen and (min-width: 1441px)': {
      fontSize: '24px',
      gap: '12px',
    },
  },
}));

export default useStyles;
